import {
  SelectInput,
  SelectInputProps,
} from "@/lib/Components/Form/Inputs/SelectInput";
import { ReceiptType } from "@/gql/graphql";
import { useTranslations } from "use-intl";

const RECEIPT_TYPE_ORDER: ReceiptType[] = [
  ReceiptType.Fuel,
  ReceiptType.Ferry,
  ReceiptType.Flight,
  ReceiptType.Toll,
  ReceiptType.Accommodation,
  ReceiptType.Transportation,
  ReceiptType.Other,
];

export function ReceiptTypeInput(
  props: Omit<SelectInputProps<ReceiptType>, "options">,
) {
  const t = useTranslations("refund.receiptType");

  return (
    <SelectInput
      {...props}
      options={[
        {
          label: "",
          options: RECEIPT_TYPE_ORDER.map((value) => ({
            value,
            label: t(value),
          })),
        },
      ]}
    />
  );
}
